export default "__VITE_ASSET__ByrUGoKU__"